const Continents = [
    {"id":"_Africa","short":"AfR"},
    {"id":"_Asia","short":"AsR"},
    {"id":"_Europe","short":"ER"},
    {"id":"_North America","short":"NAR"},
    {"id":"_Oceania","short":"OcR"},
    {"id":"_South America", "short":"SAR"}
]
//Multiple countries has been removed as i don't know what it does/means...
export default Continents;